
/**
 * NOTE: DEV-1776. Now this component the same with "ExpertTasks", but then logic,
 * columns and design of tables can change.
 */

import { Component, Vue, Watch } from "vue-property-decorator";
import { SMCases, SMTasksServices } from "@/store";
import { TTask_Table } from "@/models/tasks";
import { TASKS_TO_TRIGGER_SERVICE_UPDATE } from "@/constants/services";
import { TASK_TABS_SERVICE_EMPLOYER, TASK_TABS_NAME_EMPLOYER } from "@/constants/tasks";

const VALUE_NAME = "name";
const VALUE_STEP = "step";
const VALUE_START_DATE = "startDate";
const VALUE_END_DATE = "endDate";
const VALUE_ASSIGNED_TO = "assignedTo";
const VALUE_STATUS = "status";

@Component({
  components: {
    ToDoTasksTableTabs: () => import("@/modules/Tasks/ToDoTasksTable/ToDoTasksTableTabs.vue"),
  },
})
export default class EmployerTasks extends Vue {
  tabValues: string[] = TASK_TABS_SERVICE_EMPLOYER;

  tabNames = TASK_TABS_NAME_EMPLOYER;

  get tableProps() {
    const {
      headers,
      tabValues,
      tabNames,
      mainItems,
      mainItemsArchived,
      sideItems,
      sideItemsArchived,
    } = this;

    return {
      headers,
      tabValues,
      tabNames,
      mainItems,
      mainItemsInactive: mainItemsArchived,
      sideItems,
      sideItemsInactive: sideItemsArchived,
      countSideItemsInactive: false,
      showActions: true,
    };
  }

  get mainItems() {
    return SMTasksServices.employerTasksToDo;
  }

  get mainItemsArchived() {
    return SMTasksServices.employerTasksArchived;
  }

  get sideItems() {
    return SMTasksServices.candidateTasksToDo;
  }

  get sideItemsArchived() {
    return SMTasksServices.candidateTasksArchived;
  }

  get loading() {
    return SMTasksServices.loading;
  }

  get caseId(): number {
    return Number(this.$route.params.id);
  }

  @Watch("caseId", { immediate: true })
  async onCaseIdChange(val: number) {
    if (!val) return;

    await SMCases.setCaseId(val);
  }

  async getTableTasks() {
    await SMTasksServices.getTableTasksToDo(this.caseId);

    await SMTasksServices.getTableTasksArchived(this.caseId);

    const hasTastToUpdate = !!SMTasksServices.employerTasksToDo.find((task) =>
      TASKS_TO_TRIGGER_SERVICE_UPDATE.includes(task.name)
    );

    if (hasTastToUpdate) SMCases.setServiceNeedsUpdate(true);

    await SMCases.updateService();
  }

  async created() {
    await this.getTableTasks();
  }

  headers = [
    {
      text: this.$t("table.headers.name"),
      value: VALUE_NAME,
    },
    {
      text: this.$t("table.headers.step"),
      value: VALUE_STEP,
      filterable: true,
    },
    {
      text: this.$t("table.headers.startDate"),
      value: VALUE_START_DATE,
      sortable: true,
      sortBy: "date",
    },
    {
      text: this.$t("table.headers.endDate"),
      value: VALUE_END_DATE,
      sortable: true,
      sortBy: "date",
    },
    {
      text: this.$t("table.headers.assignedTo"),
      value: VALUE_ASSIGNED_TO,
      filterable: true,
    },
    {
      text: this.$t("table.headers.status"),
      value: VALUE_STATUS,
    },
  ];

  navigateTask(item: TTask_Table) {
    const { id, status } = item;

    this.$router.push({
      path: `/cases/tasks/${id}`,
      params: { status },
    });
  }

  async deleteTask(id: number) {
    await SMTasksServices.archiveTableTask(id);

    await this.getTableTasks();
  }
}
